import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import React from 'react'
import styled from 'styled-components'
import { accommodationIndividualRoomTileGridChildEnforcer } from './AccommodationIndividualRoomRoomTileGridBase'

export const AccommodationIndividualRoomTileDetailsContainer = styled(VerticalSpacer)`
  grid-area: details;
  ${accommodationIndividualRoomTileGridChildEnforcer}
`

interface Props {}

function AccommodationIndividualRoomTileDetails({
  children,
}: React.PropsWithChildren<Props>) {
  return <AccommodationIndividualRoomTileDetailsContainer gap={8}>
    {children}
  </AccommodationIndividualRoomTileDetailsContainer>
}

export default AccommodationIndividualRoomTileDetails
